import classNames from 'clsx';
import React, { type ReactElement, memo, useCallback } from 'react';
import { type ListChildComponentProps, areEqual } from 'react-window';
import { GALLERY_TYPES_COUNT } from 'reactApp/ui/VirtualList/VirtualList.constants';
import { getThumbTypeForGallery } from 'reactApp/ui/VirtualList/VirtualList.helpers';

import styles from './VirtualList.css';

export const VirtualListGalleryRow = memo(function VirtualListGridRow(props: ListChildComponentProps): ReactElement | null {
    const { index, style, data } = props;
    const { list, itemActiveIndex, indexes, renderItem } = data;

    const startIndex = indexes[index].start;
    const lastIndex = Math.min(indexes[index].end, list.length);
    const handleRef = index === itemActiveIndex ? data.handleRef : null;
    const gridType = index % GALLERY_TYPES_COUNT;

    const content: (JSX.Element | null)[] = [];

    const renderItemHelper = useCallback(
        (index, gridIndex) => {
            const key = String(typeof list[index] === 'string' ? list[index] : list[index].id);

            return (
                <div key={key + index} className={styles.colItem}>
                    {renderItem(list[index], { index, thumbType: getThumbTypeForGallery(gridType, gridIndex) })}
                </div>
            );
        },
        [list, gridType, renderItem]
    );

    for (let i = startIndex; i <= lastIndex; i++) {
        content.push(renderItemHelper(i, i - startIndex));
    }

    return (
        <div style={style} ref={handleRef}>
            <div
                className={classNames({
                    [styles.galleryRow]: true,
                    [styles[`galleryRow_grid_${gridType}`]]: true,
                })}
            >
                {content}
            </div>
        </div>
    );
}, areEqual);
